Customer.Ticket ||= {}

class Customer.Ticket.AuthorInfoView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/author_info']

  initialize: (@options = {}) ->
    # nothing to do

  render: ->
    following = @options.following
    @$el.html(@template({ following }))
    @
